import { useEffect } from 'react';
import store from 'store2';

import useLocation from '@skippay/core/hooks/useLocation';

const sessionKey = 'hasAttempRedirectedToApp';

/**
 * This hook is used to redirect the user to the mobile app if the user is on a mobile device. Mobile app is preferred over the web app.
 */
export function useAppRedirect(shouldRedirect: boolean): void {
	const { location } = useLocation();

	useEffect(() => {
		if (process.env.MOB_APP_BUILD) {
			return;
		}

		if (!shouldRedirect) {
			store.session.set(sessionKey, 'true');
			return;
		}

		let cleanup: NodeJS.Timeout | undefined;

		const hasRedirected = store.session.get(sessionKey);

		if (!hasRedirected) {
			const detectAndRedirectToApp = () => {
				const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

				if (isMobile) {
					const appUri = location.pathname + location.search + location.hash;

					const iframe = document.createElement('iframe');
					iframe.style.display = 'none';
					iframe.src = process.env.MOBILE_APP_URI + appUri;
					document.body.appendChild(iframe);

					cleanup = setTimeout(() => {
						document.body.removeChild(iframe);
					}, 1500);
				}
			};

			detectAndRedirectToApp();

			store.session.set(sessionKey, 'true');
		}

		// eslint-disable-next-line consistent-return
		return () => {
			if (cleanup) {
				clearTimeout(cleanup);
			}
		};
	}, [shouldRedirect, location]);
}
